import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  Box,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import request from '../../../services/Request';
import Swal from 'sweetalert2';

export default function EditTechUserModal({ open, onClose, user, onUpdate }) {
  const [hardware, setHardware] = useState(false);
  const [software, setSoftware] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setHardware(user.techResponsibilities?.hardware || false);
      setSoftware(user.techResponsibilities?.software || false);
    }
  }, [user]);

  const handleSave = async () => {
    setLoading(true);
    try {
      await request({
        method: 'patch',
        url: '/users/updateTechResponsibilities',
        data: {
          userId: user._id,
          hardware,
          software,
        },
      });

      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Tech responsibilities updated successfully',
      });

      onUpdate();
      onClose();
    } catch (error) {
      console.error('Error updating tech responsibilities:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update tech responsibilities',
      });
    }
    setLoading(false);
  };

  if (!user) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Edit Tech Responsibilities</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {user.firstname} {user.lastname}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {user.email}
          </Typography>
        </Box>

        <FormControl component="fieldset">
          <FormLabel component="legend">Responsibilities</FormLabel>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={hardware}
                  onChange={(e) => setHardware(e.target.checked)}
                />
              }
              label="Hardware"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={software}
                  onChange={(e) => setSoftware(e.target.checked)}
                />
              }
              label="Software"
            />
          </FormGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSave} disabled={loading}>
          {loading ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
